import { storeLevel } from "@/stores/level.js";
import $axios from "@/axios";

export default {
  //請求分類
  get: async function () {
    await $axios
      .post("/api/admin/level_get.php")
      .then(function (res) {
        if (res.data.result == "pass") {
          storeLevel.levels = res.data.levels;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },
};
